import React, { Suspense, lazy } from "react";

import { Loader2 } from "lucide-react";
import { Navigate } from "react-router-dom";

import useHtmlDesignsEnabled from "../../hooks/useHtmlDesignsEnabled";

const CreateDesignEntry = lazy(() => import("./CreateDesignEntry"));
const AiBriefWizard = lazy(() => import("./AiBriefWizard/AiBriefWizard"));
const HtmlDesignerPage = lazy(() => import("./HtmlDesignerPage"));

export const HTML_DESIGNER_ROLES = [
  "admin",
  "issuer",
  "tenant_admin",
  "tenant_user",
  "super_admin",
];

function DesignerSkeleton() {
  return (
    <div className="pt-[5.1rem] h-screen flex flex-col bg-cfSecondary">
      <div className="h-14 border-b border-cfCardBorder bg-cfSearchContainer" />
      <div className="flex-1 flex">
        <div className="hidden lg:block w-[22rem] border-r border-cfCardBorder" />
        <div className="flex-1 bg-[color-mix(in_srgb,var(--cf-inactive-surface-color)_60%,transparent)] flex items-center justify-center">
          <Loader2 className="h-6 w-6 animate-spin text-cfPrimary" />
        </div>
        <div className="hidden lg:block w-80 border-l border-cfCardBorder" />
      </div>
    </div>
  );
}

export default function HtmlDesignerRoute({ view }) {
  const enabled = useHtmlDesignsEnabled();
  if (!enabled) return <Navigate to="/designs" replace />;
  const Component =
    { entry: CreateDesignEntry, ai: AiBriefWizard, editor: HtmlDesignerPage }[
      view
    ] || CreateDesignEntry;
  return (
    <Suspense fallback={<DesignerSkeleton />}>
      <Component />
    </Suspense>
  );
}
